const baseApiUri = "https://ipc-zit0.onrender.com";
const apiUri = {
  similaritySearch: baseApiUri + "/similarity-search",
  legalAssist: baseApiUri + "/legal-assist",
  legalCitations: baseApiUri + "/legal-citations",
};

export default apiUri